import { AlertTriangle, CheckCircle2 } from "lucide-react";
import type { DreDoPeriodo } from "@/lib/dinheiro";

type Props = { confianca: DreDoPeriodo["confianca"]; config: DreDoPeriodo["config"]; mesAtual: boolean; onConfigurar: () => void };

/** O que falta para o DRE do mês ser confiável: um DRE bonito com dado faltando dá falsa segurança. */
export function ConfiancaDoMes({ confianca: c, config, mesAtual, onConfigurar }: Props) {
  const itens: { texto: string; acao?: () => void; rotuloDaAcao?: string }[] = [];
  if (c.semLinha > 0) itens.push({ texto: `${c.semLinha} ${c.semLinha === 1 ? "lançamento em categoria" : "lançamentos em categorias"} sem linha do DRE (caem em Outras despesas).`, acao: onConfigurar, rotuloDaAcao: "Classificar" });
  if (c.semAliquota) itens.push({ texto: "Alíquota sobre o faturamento não informada: sem o imposto lançado, a linha fica zerada.", acao: onConfigurar, rotuloDaAcao: "Informar" });
  if (c.comprasSemBem > 0) itens.push({ texto: `${c.comprasSemBem} ${c.comprasSemBem === 1 ? "compra de equipamento ainda não cadastrada" : "compras de equipamento ainda não cadastradas"} como bem: a depreciação dela não entra.`, acao: onConfigurar, rotuloDaAcao: "Cadastrar" });
  if (c.semFolha) itens.push({ texto: "Folha do mês não lançada: sem ela, Pessoal e a provisão de 13º e férias ficam de fora." });
  if (c.semPreco > 0) itens.push({ texto: `${c.semPreco} ${c.semPreco === 1 ? "serviço concluído sem preço" : "serviços concluídos sem preço"}: fora da receita.` });
  if (config.custoDoMaterial === "FICHA" && c.cobertura.concluidos > 0 && c.cobertura.comFicha < c.cobertura.concluidos) {
    const pct = Math.round((c.cobertura.comFicha / c.cobertura.concluidos) * 100);
    itens.push({ texto: `${pct}% dos serviços concluídos têm ficha técnica: o custo do material dos outros não entra.` });
  }
  if (!c.fechado && !mesAtual) itens.push({ texto: "Mês não fechado: os números ainda podem mudar." });

  if (!itens.length) {
    return (
      <p className="flex items-center gap-1.5 text-xs text-zinc-500 dark:text-muted-foreground">
        <CheckCircle2 className="h-3.5 w-3.5 text-emerald-600" />
        {c.fechado ? "Mês fechado e completo." : "Nada pendente no mês até agora."}
      </p>
    );
  }
  return (
    <ul className="space-y-1 rounded-lg bg-amber-50 p-3 text-xs text-amber-800 dark:bg-amber-500/10 dark:text-amber-300">
      {itens.map((i) => (
        <li key={i.texto} className="flex gap-1.5">
          <AlertTriangle className="mt-px h-3.5 w-3.5 shrink-0" />
          <span>
            {i.texto}
            {i.acao && (
              <button type="button" onClick={i.acao} className="ml-1 font-semibold underline underline-offset-2 hover:no-underline">
                {i.rotuloDaAcao}
              </button>
            )}
          </span>
        </li>
      ))}
    </ul>
  );
}
